// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IHashIdOverridablePropertiesDto
 */
export interface IHashIdOverridablePropertiesDto {
    /**
     * 
     * @type {string}
     * @memberof IHashIdOverridablePropertiesDto
     */
    partner_mobile_app?: IHashIdOverridablePropertiesDtoPartnerMobileAppEnum;
    /**
     * 
     * @type {string}
     * @memberof IHashIdOverridablePropertiesDto
     */
    partner_app_ios_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IHashIdOverridablePropertiesDto
     */
    partner_app_android_link?: string;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IHashIdOverridablePropertiesDto
     */
    logo_info?: IOrganizationLogoDto;
}

/**
* @export
* @enum {string}
*/
export enum IHashIdOverridablePropertiesDtoPartnerMobileAppEnum {
    NONE = 'NONE',
    ELEVATE_APP = 'ELEVATE_APP',
    PARTNER_OWN_APP = 'PARTNER_OWN_APP'
}


/**
 * Check if a given object implements the IHashIdOverridablePropertiesDto interface.
 */
export function instanceOfIHashIdOverridablePropertiesDto(value: object): value is IHashIdOverridablePropertiesDto {
    return true;
}

export function IHashIdOverridablePropertiesDtoFromJSON(json: any): IHashIdOverridablePropertiesDto {
    return IHashIdOverridablePropertiesDtoFromJSONTyped(json, false);
}

export function IHashIdOverridablePropertiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHashIdOverridablePropertiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partner_mobile_app': json['partner_mobile_app'] == null ? undefined : json['partner_mobile_app'],
        'partner_app_ios_link': json['partner_app_ios_link'] == null ? undefined : json['partner_app_ios_link'],
        'partner_app_android_link': json['partner_app_android_link'] == null ? undefined : json['partner_app_android_link'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
    };
}

export function IHashIdOverridablePropertiesDtoToJSON(json: any): IHashIdOverridablePropertiesDto {
    return IHashIdOverridablePropertiesDtoToJSONTyped(json, false);
}

export function IHashIdOverridablePropertiesDtoToJSONTyped(value?: IHashIdOverridablePropertiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partner_mobile_app': value['partner_mobile_app'],
        'partner_app_ios_link': value['partner_app_ios_link'],
        'partner_app_android_link': value['partner_app_android_link'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
    };
}

